<template>
  <div id="container" class="container">
    <div class="row mt-3">
      <div id="content-area" class="col-sm-9">
        <slot v-bind:itemInfoChanged="itemInfo"></slot>
      </div>
      <div class="col-sm-3 text-light">
        <MeetingCameraSetting :type="type" @changeIsOperationPossible="changeIsOperationPossible"/>
        <div class="position-relative" v-if="itemInfo && customerDisplayFlag">
          <BButton class="mt-2 position-absolute" variant="light" @click="toggleTable" style="right: 10px;">
            <i class="bi bi-x" v-if="tableShow"></i>
            <i class="bi bi-list" v-else></i>
          </BButton>
        </div>
        <div class="table-scroll" v-if="tableShow && itemInfo && customerDisplayFlag" style="margin-bottom: 1rem;">
          <table class="table table-bordered table-sm meeting-table mt-5" style="min-width: 400px; margin-bottom: 0;">
            <thead>
              <tr>
                <th style="width: 50px">大区分</th>
                <th v-if="inputFlg && !singleFlg" colspan="2">商品名</th>
                <th v-else style="width: 100px">商品名</th>
                <th style="width: 30px">数量</th>
                <th style="width: 100px">備考</th>
              </tr>
            </thead>
            <tbody v-for="(items, category) in itemInfo" :key="category">
              <tr v-for="(item, index) in items" :key="index">
                <td class="align-middle text-start" :rowspan="Object.keys(items).length" v-if="index === 0">{{category}}</td>
                <td v-if="inputFlg && !singleFlg" class="align-middle text-start" style="width: 10%"><input type="checkbox" v-model="item['checked']"></td>
                <td v-if="inputFlg" class="align-middle text-start">{{item['itemName']}}<br>¥&nbsp;<input type="text" class="input-product-selection-price" v-model="item['itemPriceRaw']"></td>
                <td v-else class="align-middle text-start">{{item['itemName']}}<br><div :id="'productSelectionPrice'+index">{{item['itemPrice']}}</div></td>
                <td v-if="inputFlg" class="align-middle text-end"><input type="text" class="input-product-selection-quantity" v-model="item['quantity']"></td>
                <td v-else class="align-middle text-end" :id="'productSelectionQuantity'+index">{{item['quantityDef']}}</td>
                <td v-if="inputFlg" class="align-middle text-start"><textarea type="text" class="input-product-selection-remarks" v-model="item['itemRemarks']" maxlength="50"></textarea></td>
                <td v-else class="align-middle text-start" style="white-space:pre-wrap;" :id="'productSelectionRemarks'+index">{{item['itemRemarksDef']}}</td>
              </tr>
              <tr class="tr-total" v-if="totalShow">
                <td>{{category.replace('テーブル', '')}}<br>合計</td>
                <td v-if="inputFlg" class="text-end" :colspan="2">{{putTotalPriceRaw(items)}}</td>
                <td v-else class="text-end" :colspan="2">{{putTotalPrice(items)}}</td>
                <td :colspan="2"></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MeetingCameraSetting from '@/components/MeetingCameraSetting'
export default {
  name: 'CustomerMeetingLayout',
  components: { MeetingCameraSetting },
  props: {
    'type': Number,
    'itemInfo': Object,
    'inputFlg': Boolean,
    'singleFlg': Boolean,
    'totalShow': Boolean,
    'customerDisplayFlag': Boolean
  },
  data () {
    return {
      tableShow: true
    }
  },
  methods: {
    toggleTable () {
      if (this.tableShow === true) {
        this.tableShow = false
      } else {
        this.tableShow = true
      }
    },
    putTotalPrice (items) {
      let totalPrice = 0
      for (const item of items) {
        const priceStr = String(item['itemPrice'])
        const quantityStr = String(item['quantityDef'])
        let price = 0
        if (priceStr.length !== 0) {
          price = Number(priceStr.replace(/¥|,/g, ''))
        }
        let quantity = 0
        if (quantityStr.length !== 0) {
          quantity = Number(quantityStr.replace(/¥|,/g, ''))
        }
        totalPrice += price * quantity
      }
      totalPrice = totalPrice.toLocaleString()
      return '¥' + totalPrice
    },
    putTotalPriceRaw (items) {
      let totalPrice = 0
      for (const item of items) {
        const priceStr = item['itemPriceRaw']
        let price = 0
        if (priceStr.length !== 0) {
          price = Number(priceStr)
        }
        const quantityStr = item['quantity']
        let quantity = 0
        if (quantityStr.length !== 0) {
          quantity = Number(quantityStr)
        }
        totalPrice += price * quantity
      }
      totalPrice = totalPrice.toLocaleString()
      return '¥' + totalPrice
    },
    changePriceAndQuantity (newData) {
      if (newData['data'].id.includes('productSelectionPrice')) {
        this.itemInfo[newData['data'].category][(newData['data'].categorySerialNumber)]['itemPrice'] = '¥' + newData['data'].value
      }
      if (newData['data'].id.includes('productSelectionQuantity')) {
        this.itemInfo[newData['data'].category][(newData['data'].categorySerialNumber)]['quantityDef'] = newData['data'].value
      }
      if (newData['data'].id.includes('productSelectionRemarks')) {
        this.itemInfo[newData['data'].category][(newData['data'].categorySerialNumber)]['itemRemarksDef'] = newData['data'].value
      }
    },
    changeIsOperationPossible (value) {
      this.$emit('changeIsOperationPossible', value)
    }
  },
  mounted () {
    if (this.type === this.consts.meetingType.florist || this.type === this.consts.meetingType.floristStyleImageProposal) {
      document.getElementById('container').style.paddingTop = '54px'
    }
  }
}
</script>
<style>
.tr-total {
  font-weight: 700;
}
</style>
